import { render } from "./VideoConsultationIcon.vue?vue&type=template&id=732caefd"
import script from "./VideoConsultationIcon.vue?vue&type=script&lang=js"
export * from "./VideoConsultationIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__